import Progress from '@mui/material/CircularProgress'


export default function LazyLoading() {
  return (
    <div className="flex justify-center items-center h-full">
      <Progress/>
    </div>
  )
}
